import { Layer, Box, Text, Anchor } from 'grommet';
import React from 'react';
import useTranslation from 'next-translate/useTranslation';

type Props = {
	setShow: (show: boolean) => void;
};

export const DeviceUsedByOtherProcess = ({ setShow }: Props) => {
	const { t } = useTranslation('default');
	return (
		<Layer onEsc={() => setShow(false)} onClickOutside={() => setShow(false)}>
			<Box pad="large">
				<Text weight="bold">{t('modals.device_being_used')}</Text>
				<Text margin={{ top: '10px', bottom: '10px' }}>
					{t('modals.device_being_used_description')}
				</Text>
				<Anchor
					onClick={() => setShow(false)}
					size="xsmall"
					label={t('modals.continue_no_mic')}
				/>
			</Box>
		</Layer>
	);
};
